/**
 * ColorSwatch - A clickable color picker swatch component
 */

interface ColorSwatchProps {
  color: string;
  index: number;
  onChange: (index: number, color: string) => void;
}

function ColorSwatch({ color, index, onChange }: ColorSwatchProps) {
  return (
    <div className="flex flex-col items-center gap-1">
      <label className="relative cursor-pointer" title={`Color ${index + 1}`}>
        <input
          type="color"
          value={color}
          onChange={(e) => onChange(index, e.target.value)}
          className="sr-only"
        />
        <div
          className="w-10 h-10 rounded-lg border-2 border-border hover:border-primary transition-colors"
          style={{ backgroundColor: color }}
        />
      </label>
      <span className="text-[10px] text-muted-foreground font-mono">
        {color.toUpperCase()}
      </span>
    </div>
  );
}

export { ColorSwatch };
export type { ColorSwatchProps };
